import React from 'react';
import Navbar from '../gral-components/Navbar';
import Header from '../gral-components/Header';
import BorderCurved from '../gral-components/BorderCurved';
import Subtitles from '../gral-components/Subtitles';
import Footer from '../gral-components/Footer';
import './about-us.scss';

import about from '../data/dearHR/dearHR-about.json';
import staff from '../data/dearHR/dearHR-staff.json';



class AboutUs extends React.Component { 
  render() {
    return (
      <div className='background-gradient-image'>
        <div
          id='header-home'
          className='header-about-us'
        >
          <Navbar
            searchBar={false}
            aboutUs={true}
            navbarType='about-us'
            loginOpenHandle={this.props.loginOpenHandle}
            joinOpenHandle={this.props.joinOpenHandle}
          />
          <Header
            headerType='about-us'
            images={''}
          />
        </div>
        <div className='main-content'>
          <div className='border-curved-top-container'>
            <BorderCurved
              transform={false}
              background={{
                backgroundImage: 'none'
              }}
              fill='white'
            />
          </div>
          <div className='about-us-about-us-content'>
            {
              about.map((item, index) =>
                <div
                  key={index}
                  className='about-us-about-us-item-container'>
                  <div className='subtitles-container'>
                    <Subtitles
                      darkText={true}
                      titleSmall=''
                      titleBig={item.titleBig}
                    />
                  </div>
                  <div className='about-us-about-us-item'>
                    <h2>{item.text}</h2>
                  </div>
                </div>
              )
            }
            <div className='about-us-about-us-item-container'>
              <div className='subtitles-container'>
                <Subtitles
                  darkText={true}
                  titleSmall=''
                  titleBig='Staff'
                />
              </div>
              <ul className='about-us-about-us-item-ul'>
                {
                  staff.map((item, index) =>
                    <li
                      key={index}
                      className='about-us-about-us-item-li'
                    >
                      <div className='staff-item'>
                        <img
                          className='staff-image'
                          src={item.image}
                          alt={item.alt}
                        />
                        <div className='staff-name'>
                          <h3>{item.name}</h3>
                        </div>
                      </div>
                      <div className='staff-position'>
                        <h3>{item.position}</h3>
                      </div>
                    </li>
                  )
                }
              </ul>
            </div>
          </div>
          <div className='border-curved-bottom-container'>
            <BorderCurved
              transform={true}
              background={{
                backgroundColor: 'rgba(0, 0, 0, 0.7)'
              }}
              fill='white'
            />
          </div>
        </div>
        <footer
          id='footer-section'
          className='footer-section flex-column-center-center' >
          <Footer
            footerMini={false}
          />
        </footer>
      </div>
    );
  }

};

export default AboutUs;